import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Brush, CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts';
import * as dataService from "../service/data-info-chart/requestsUtil";
import {ANNUAL_ACCOUNTS, COLORS, GRAPH_MARGIN, WHITOUT_INFORMATION} from "../utils/constants";
import * as cbu from "../utils/checkBusinessUnit";
import * as formatter from "../utils/formatters"

var Loader = require('react-loader');

class AnnualAccounts extends Component {

  constructor(props) {
    super(props);
    this.state = {datas: [], loaded: false, date: this.props.date};
  }

  componentDidMount() {
    let params = {
      id: cbu.checkBusinessUnit(this.props.bu),
      date: this.state.date
    };

    dataService.postFetch(ANNUAL_ACCOUNTS, params)
      .then((data) => {
        this.setState({datas: data, loaded: true});
      });
  }

  componentWillReceiveProps(nextProps) {
    let params = {
      id: cbu.checkBusinessUnit(this.props.bu),
      date: this.props.date
    };

    dataService.postFetch(ANNUAL_ACCOUNTS, params)
      .then((data) => {
        this.setState({datas: data, loaded: true, date: nextProps.date});
      });
  }

  render() {
    if (this.state.datas.length > 0) {
      return (
        <Loader loaded={this.state.loaded} top="90%">
          <ResponsiveContainer>
            <LineChart width={600} height={300} data={this.state.datas}
                       margin={GRAPH_MARGIN}>
              <XAxis dataKey="month"/>
              <YAxis domain={[0, 'dataMax + 200']} scale={'linear'}/>
              <CartesianGrid/>
              <Tooltip/>
              <Legend verticalAlign={"top"}/>
              <Line type="linear" name={"Cuentas"} dataKey="amount" stroke={COLORS.AMOUNT}/>
              <Brush dataKey={"mes"} height={20}/>
            </LineChart>
          </ResponsiveContainer>
        </Loader>
      );
    } else {
      return (<Loader loaded={this.state.loaded} top="50%"><h2
        className="without-avilable-information">{WHITOUT_INFORMATION}</h2></Loader>);
    }
  }
}

// Connect linechartdata as props to compenent
function mapStateToProps(state) {
  return {
    lineChartData: state.monthlyRecovery
  }
}

export default connect(mapStateToProps)(AnnualAccounts);




// WEBPACK FOOTER //
// ./src/charts/annualAccounts.js